/* eslint-disable no-unused-vars */
import settingService from "@/services/setting";

export const state = {
  childSettings: [],
  loadingStatus: false,
};

export const actions = {
  fetchChildSettings({ commit }) {
    return new Promise((resolve, reject) => {
      settingService
        .getChildSettings()
        .then((data) => {
          commit("setChildSettings", data.data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  sendInstructions({ commit }, payload) {
    const obj = {
      user_id: payload.user_id,
      entity_id: payload.entity_id,
      kiosk_id: payload.kiosk_id
    };
    return new Promise((resolve, reject) => {
      settingService
        .sendInstructions(obj)
        .then((data) => {
          resolve(data);
          if (payload.single) this._vm.$toast.success(data.message);
        })
        .catch((err) => reject(err));
    });
  },

  getOnlineKiosks({ commit }) {
    return new Promise((resolve, reject) => {
      settingService
        .getOnlineKiosks()
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  verifyRFIDCode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      settingService
        .verifyRFIDCode(payload)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

};

export const mutations = {
  loadongStatus(state, loading) {
    state.loadingStatus = loading;
  },
  setChildSettings(state, payload) {
    state.childSettings = payload;
  },
};

export const getters = {
  loadingStatus(state) {
    return state.loadingStatus;
  },
  getchildSettings(state) {
    return state.childSettings;
  },
};
